import { OverlayPage } from '@pages/overlay'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

function NotFound() {
  return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',background:'#0a0a0e',color:'#fff',fontFamily:'sans-serif',flexDirection:'column',gap:12}}>
      <h1 style={{fontSize:'3rem',margin:0}}>404</h1>
      <p style={{color:'rgba(255,255,255,0.5)',margin:0}}>Overlay not found. Check your stream URL.</p>
    </div>
  )
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/overlay/:streamerId" element={<OverlayPage />} />
        <Route path="/" element={<Navigate to="/overlay/demo" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  )
}
